define([
	"dojo/_base/declare",
	"csi/prefs/PreferenceView"
], function(declare, PreferenceView) {

	const _deprecatedDefaultLabel = "__Default__";

	return declare(PreferenceView, {
		customOptions: [
			{name: "attributeKeys", personalized: true, value: []},
			{name: "displayPropertyImage", formerName: "PropertyImage", value: true},
			{name: "hiddenKeys", personalized: true, value: []},
			{name: "imageSize", formerName: "ImageSize", value: ""},
			{name: "propertyShowThumbnailLabel", value: false},
			{name: "propertyColumns", formerName: "PropertyColumns", value: 0},
			{name: "propertyImageLabel", formerName: "PropertyImageLabel", value: ""},
			{name: "propertyImageHeight", formerName: "PropertyImageHeight", value: ""},
			{name: "propertyImageWidth", formerName: "PropertyImageWidth", value: ""},
			{name: "printComments", omitFromPreview: true, value: false},
			{name: "printHeader", omitFromPreview: true, value: false},
			{name: "printOrientation", formerName: "Orientation", omitFromPreview: true, value: ""},
			{name: "printPaper", formerName: "PaperSize", omitFromPreview: true, value: ""},
			{name: "showFileSizes", formerName: "ShowFileSizes", value: false}
		],

		/**
		 * Reset image label if referencing previously used default value
		 */
		_propertyImageLabelLoad(value, options, mapKey) {
			return (value === _deprecatedDefaultLabel) ? "" : value;
		},

		/**
		 * Return numeric value for columns value - sometimes stored as string
		 * @param {Value} value - starting value for the columnsLoad
		 * @param {Options} options - Options for fetching the columns
		 * @param {Key} mapKey - kep mapping for columns
		 * @return {number} - remapped value.  Needs to at least return the original value
		 */
		_propertyColumnsLoad: function(value, options, mapKey) {
			return parseInt(value);
		}
	});
});